import { useQuery } from '@tanstack/react-query';
import { formsApiClient } from '../services/fetch/forms-api-client';
import { loadColumns } from './use-form-app';
import { useApp } from './use-app';
import { QueryColumnResponse, RestApiForm } from '../tasks/types';

export interface AppData {
  restForm: RestApiForm;
  queryColumns: QueryColumnResponse;
}

export default function useForm(resourceId: string) {
  const app = useApp();

  const apiClient = formsApiClient(app.api.token);

  const loadFormData = async () => {
    // We need to get the SystemApp via rest, and the schema from query,
    // both of which are needed to get records from query
    const { form: rawForm } = await apiClient.fetchForm(resourceId);
    const rawColumns = await loadColumns(app.dataSource, resourceId);

    const loadedData: AppData = {
      restForm: rawForm,
      queryColumns: rawColumns,
    };
    return loadedData;
  };

  return useQuery(['form_data', resourceId], loadFormData,
    {
      refetchOnWindowFocus: false,
    });
}
